window.addEventListener('load', function(){
  (function ($) {
    'use strict';

    // Function definitions


    function itemTemplate(item){
      var image = '<img src="' + item.image + '" data-src="' + item.image + '" data-original-src="' + item.image + '" class="bundle-item-image" alt="' + item.title + '"/>',
          li = '<li class="bundle-item" data-value="' + item.id + '" data-title="' + item.title.toString().replace(/"/gi, '&quote;') + '" data-vendor="' + item.vendor.toString().replace(/"/gi, '&quote;') + '">'
      + image + '<span class="bundle-item-label">' + item.title + ' ' + Shopify.formatMoney(item.price) + '</span>'
      + '</li>';

      return li;
    }

    function optionTemplate(item) {
      var option = '<option value="' + item.id + '" data-options="' + item.options.toString().replace(/"/gi, '&quote;') + '"'
      +'data-init-value="1"'
      +'data-product-handle="/collections/' + item.collection_handle + '/products/' + item.product_handle + '"'
      +'data-tags="' + item.tags.toString().replace(/"/gi, '&quote;') + '"'
      +'data-sku="' + item.sku + '" '
      +'data-price="' + item.price + '"'
      +'data-variant-inventory="' + item.inventory_management + '"'
      +'data-inventory_policy="' + item.inventory_policy + '"'
      +'data-inventory="' + item.data_inventory + '"'
      +'data-compare-at-price="' + item.compare_at_price + '"'
      +'data-image="' + item.image + '"'
      +'data-original-src="' + item.original_image + '"'
      +'data-title="' + item.product_title.toString().replace(/"/gi, '&quote;') + ' ' + item.title.toString().replace(/"/gi, '&quote;') + '"'
      +'data-vendor="' + item.vendor + '"'
      +'required>'
      +'' + item.title + ' / ' + item.price + ''
      +'</option>';

      return option;
    }
    
    function noProducts( label ) {
      return '<li class="bundle-item bundle-item-no-products" style="min-height: unset;">' + label + '</li>';
    }

    /**
       * Check if possible update add a new bundle.
       * 
       * @param {Object} self Object jQuery
       * 
       * @return {Boolean}
       */
    function can_add_bundle(self) {
      var item = self.closest('.bundle-procucts-item'),
          bundles_amount = item.find('.bundle-variants-wrapper').length,
          max = item.find('.bundle-size').eq(0).val();

      return bundles_amount < max;
    }

    /**
       * Close all opened options.
       */
    function close_all_options(event) {
      var element;

      if (event) {
        element = $(event.target);

        if (!element.is('.bundle-product-mask *, .disabled')) {
          $('.bundle-product-mask').removeClass('active');

          $('.bundle-product-mask').each(function(){
            $(this).scrollTop(0)
          });
        }
      }
    }

    async function getCollectionProducts( collection, callback ) {
      return await $.get('/collections/' + collection + '?view=all-products-ajax', callback);
    }

    function displayItems( items, container, selectContainer ) {
      items = JSON.parse(items.replace('},]', '}]'));

      if (items && items.length > 0) {
        items.forEach(function(item){
          container.append(itemTemplate(item));
          selectContainer.append(optionTemplate(item));
          Shopify.Image.loadImage(item.image);
        });

        $('.builder-item-loading', container).remove();

        $('.bundle-item').hover(function(){
          
          var src = $(this).find('img').eq(0).attr('data-original-src'),
              title = $(this).attr('data-title');

          $(this).addClass('last-hovered').siblings().removeClass('last-hovered');

          $(this).closest('.item-single').find('.background-image img').attr('src', src);
          $(this).closest('.item-single').find('.item-title a').html(title);
        }, function(){
          var src = $(this).closest('.item-single').find('.bundle-item.active img').eq(0).attr('data-original-src'),
              title = $(this).closest('.item-single').find('.item-title').eq(0).attr('data-original-title');

          $(this).closest('.item-single').find('.background-image img').attr('src', src);

          if ($(this).closest('.item-single').find('.all-bundle-variants').eq(0).val() != 'choose-variant') {
            $(this).closest('.item-single').find('.item-title').eq(0).attr('data-original-title', title).find('a').html(title);
          }
        });
      } else {
        $('.builder-item-loading', container).remove();

        container.append(noProducts('No Available Products'));
      }
    }

    /**
       * Open bundle options
       */
    async function open_bundle_options(e) {
      var self = $(this),
          target = $(e.target),
          collection = self.closest('[data-handle]').attr('data-handle'),
          selectContainer = self.closest('.bundle-variants-wrapper').find('.all-bundle-variants').eq(0),
          variants;

      if (!target.hasClass('disabled')) {
        $('.bundle-product-mask').not(self).removeClass('active');
        $(this).find('.bundle-item').removeClass('last-hovered');

        if (!target.hasClass('bundle-filter')) {
          self.toggleClass('active');
        }

        if ($('.builder-item-loading', self).length > 0) {
          variants = await getCollectionProducts(collection);

          displayItems(variants, self, selectContainer);
        }
      }
    }

    /**
       * Select a bundle option element in the mask.
       */
    function select_bundle_option() {
      var self = $(this),
          bundle_product_mask_wrapper = self.closest('.bundle-product-mask-wrapper'),
          value;

      if (!self.hasClass('active') && !self.hasClass('disabled')) {
        value = self.data('value');

        self.addClass('active').siblings().removeClass('active');
        empty_filter();
        
        if (value != 'choose-variant') {
        	bundle_product_mask_wrapper.siblings('.all-bundle-variants').val(value).trigger('change').prop('disabled', false);
          	bundle_product_mask_wrapper.siblings('.bundle-quantity').prop('disabled', false);
        } else {
          bundle_product_mask_wrapper.siblings('.all-bundle-variants').val(value).trigger('change').prop('disabled', true);
          bundle_product_mask_wrapper.siblings('.bundle-quantity').prop('disabled', false);
        }
      }
    }

    /**
       * Update ATC quantity.
       */
    function update_total_quantity() {
      var total_quantity = 0,
          btn_items = $('.bundle-atc-button').find('.btn-items');

      $('.all-bundle-variants').each(function () {
        if ($(this).val() != 'choose-variant')
          total_quantity++;
      });

      btn_items.html('(' + total_quantity + (total_quantity != 1 ? ' Items' : ' Item') + ')');
    }

    /**
       * Update ATC total price.
       */
    function update_total_price() {
      var form = $('#bundle-form'),
          prices = form.find('.total-price > .price'),
          bundle_add_to_cart = $('.bundle-atc-button'),
          btn_money = bundle_add_to_cart.find('.btn-money'),
          total_price = 0,
          price,
          availableProducts = parseInt($('.item-single').length - $('.item-single .bundle-optional').length),
          selectedItems = availableProducts - parseInt($('.all-bundle-variants[required] option:selected').filter('[value="choose-variant"]').length);

      prices.each(function () {
        price = $(this).text().replace(/[^0-9]/gi, '');
        price = parseFloat(price);
        total_price += price;
      });


      if (selectedItems == availableProducts) {
        bundle_add_to_cart.prop('disabled', false);
      } else {
        bundle_add_to_cart.prop('disabled', true);
      }

      btn_money.html(Shopify.formatMoney(total_price, '${{amount}}'));
      $('#bundle-subtotal-price').html(Shopify.formatMoney(total_price, '${{amount}}'));

      update_total_quantity();
    }

    /**
       * Update the item total price.
       * 
       * @param {Object} self Object jQuery
       */
    function update_item_total_price(self) {
      var bundle = self.closest('.bundle-procucts-item'),
          handle = bundle.attr('data-handle'),
          checkedPrice = $(document.getElementById('checked-' + handle + '-price')),
          bundleProductInfo = checkedPrice.closest('.bundle-products-info'),
          all_variants = bundle.find('.all-bundle-variants'),
          total_price = 0,
          quantity,
          variant,
          price;

      quantity = parseInt(quantity);

      all_variants.each(function () {
        variant = $(this).find('option:selected');
        quantity = $(this).siblings('.bundle-quantity').eq(0).val(),
          price = variant.data('price');

        if (price) {
          price = parseInt(price);
          price *= quantity;
        } else {
          price = 0;
        }

        total_price += price;
      });

      bundle.find('.total-price > .price').html(Shopify.formatMoney(total_price, '${{amount}}'));

      if (total_price != 0) {
        bundleProductInfo.addClass('checked');
        checkedPrice.html( Shopify.formatMoney(total_price, '${{amount}}') );
      } else {
        bundleProductInfo.removeClass('checked');
        checkedPrice.html('');
      }

      update_total_price();
    }

    /**
       * @param {Object} self Object
       */
    function disable_selected_option(self) {
      var bundle_variants_wrapper = self.closest('.bundle-variants-wrapper'),
          current_bundle,
          current_options,
          selected_option,
          next_bundle;

      bundle_variants_wrapper.each(function () {
        current_bundle = $(this);
        current_options = current_bundle.find('option').not('[value="choose-variant"],.bundle-item-variant');

        current_bundle.nextAll().each(function (i) {
          next_bundle = $(this);

          next_bundle.find('option').attr('disabled', false);
          next_bundle.find('.bundle-product-mask > .bundle-item').removeClass('disabled');

          current_options.each(function () {
            selected_option = $(this);

            next_bundle.find('.bundle-product-mask > .bundle-item.disabled').removeClass('active');

            if (selected_option.attr('disabled')) {
              next_bundle.find('option').filter('[value="' + selected_option.val() + '"]').attr('disabled', true);
              next_bundle.find('.bundle-product-mask > .bundle-item').filter('[data-value="' + selected_option.val() + '"]').addClass('disabled');
            }

            if (selected_option.is(':selected')) {
              next_bundle.find('option').filter('[value="' + selected_option.val() + '"]').attr('disabled', true);
              next_bundle.find('.bundle-product-mask > .bundle-item').filter('[data-value="' + selected_option.val() + '"]').addClass('disabled');
            }
          });
        });
      });
    }

    /**
       * Reset new bundle.
       * 
       * @param {Object} new_bundle 
       */
    function reset_new_bundle(new_bundle) {
      if (!new_bundle) {
        new_bundle = $('.bundle-product-mask.active');
      }

      new_bundle.find('.bundle-filter').val('');
      new_bundle.find('.bundle-item').removeClass('active hide');
      new_bundle.find('[data-value="choose-variant"]').addClass('active').trigger('click');
    }

    /**
       * Reset all variants.
       * 
       * @param {Object} self Object jQuery
       */
    function reset_all_variants(self, value) {
      var bundle_variants_wrapper = self.closest('.bundle-variants-wrapper'),
          bundle,
          next_siblings = bundle_variants_wrapper.nextAll();

      if (next_siblings.length > 0) {
        next_siblings.each(function () {
          bundle = $(this);

          bundle.find('.all-bundle-variants').val('choose-variant').trigger('change');
          bundle.find('.bundle-product-mask > .bundle-item').removeClass('active').eq(0).addClass('active');
        });
      }

      disable_selected_option(self);
    }

    /**
     * On Change Variant
     */
    function change_variant() {
      var self = $(this),
          article = self.closest('.item-single'),
          quantity = self.siblings('.bundle-quantity'),
          variant = self.find('option:selected'),
          initValue = parseInt(variant.parent().attr('data-init-value')),
          variantPrice = variant.attr('data-price'),
          variantTitle = variant.attr('data-title'),
          variantHandle = variant.attr('data-product-handle'),
          variantImage = variant.attr('data-original-src'),
          bundlePlus = self.closest('.item-single').find('.bundle-btns.full'),
          image;

      self.closest('.item-single').find('.item-title').attr('data-original-title', variantTitle).find('a').html(variantTitle);
      self.closest('.item-single').find('.background-image img').attr('src', variantImage);    
      self.closest('.item-single').find('a.product-link').attr('href', variantHandle).attr('title', variantTitle);

      if (/^[0-9]+/ig.test(variant.val())) {
        image = variant.attr('data-image');

        self.closest('.item-single').find('.background-image img').attr('src', image);
        self.closest('.item-single').find('.price').attr('data-price', variantPrice).html(Shopify.formatMoney(variantPrice, '${{amount}}'));

        quantity.val(initValue);
        bundlePlus.removeClass('additem');
        article.addClass('selected');
      } else {
        quantity.val(0);
        bundlePlus.addClass('additem');
        article.removeClass('selected');
      }

      $('.bundle-product-mask').each(function(){
        $(this).scrollTop(0)
      });

      update_item_total_price(self);

      reset_on_change_bundle(self);

      // reset_all_variants(self);
    }

    function reset_on_change_bundle(self) {
      var self_bundle_wrapper,
          self_bundle_options,
          self_current_option,
          next_bundles,
          next_options,
          next_current_option;

      do {
        self_bundle_wrapper = self.closest('.bundle-variants-wrapper');
        next_bundles = self_bundle_wrapper.next();

        if (next_bundles.length > 0) {
          self_bundle_options = self_bundle_wrapper.find('option').not('[value="choose-variant"]');
          next_options = next_bundles.find('option').not('[value="choose-variant"]');

          next_options.attr('disabled', false);
          next_options.closest('.bundle-variants-wrapper').find('.bundle-product-mask > .bundle-item').removeClass('disabled');

          self_bundle_options.each(function(){
            self_current_option = $(this);

            next_options.each(function(){
              next_current_option = $(this);

              if (self_current_option.val() == next_current_option.val()) {
                if (self_current_option.is(':selected') || self_current_option.attr('disabled')) {
                  next_current_option.attr('disabled', true);
                  next_current_option.closest('.bundle-variants-wrapper').find('.bundle-product-mask > .bundle-item').filter('[data-value="' + self_current_option.val() + '"]').addClass('disabled');
                }

                if (self_current_option.attr('disabled') && next_current_option.is(':selected')) {
                  next_current_option.attr('disabled', true).parent().val('choose-variant');
                  next_current_option.closest('.bundle-variants-wrapper').find('.bundle-product-mask > .bundle-item').removeClass('active').filter('[data-value="choose-variant"]').addClass('active');
                }

                if (self_current_option.is(':selected') && next_current_option.is(':selected')) {
                  next_current_option.attr('disabled', true).parent().val('choose-variant');
                  next_current_option.closest('.bundle-variants-wrapper').find('.bundle-product-mask > .bundle-item').removeClass('active').filter('[data-value="choose-variant"]').addClass('active');
                }
              }
            });
          });

          self = next_options;
        }
      } while(next_bundles.length > 0);
    }

    /**
       * 
       * @param {Object} self Starting point.
       */
    function enable_next_options(self) {
      var bundle_variants_wrapper = self.closest('.bundle-variants-wrapper'),
          all_next_bundle_disabled_options = bundle_variants_wrapper.nextAll().find('option'),
          current_option,
          current_bundle,
          all_bundle_variants_value = bundle_variants_wrapper.find('.all-bundle-variants').eq(0).val();

      all_next_bundle_disabled_options.each(function () {
        current_option = $(this);
        current_bundle = current_option.closest('.bundle-variants-wrapper');

        if (current_option.attr('disabled') && current_option.val() == all_bundle_variants_value) {
          current_option.attr('disabled', false);
          current_bundle.find('.bundle-product-mask > .bundle-item').filter('[data-value="' + all_bundle_variants_value + '"]').removeClass('disabled');
        }
      });
    }

    /**
       * Add a new bundle.
       */
    function add_bundle() {
      var self = $(this),
          bundle_wrapper = self.closest('.bundle-variants-wrapper'),
          new_bundle_wrapper = self.closest('.bundle-variants-wrapper').clone(),
          bundle_variants = self.closest('.bundle-variants');

      if (can_add_bundle(self)) {

        reset_new_bundle(new_bundle_wrapper);

        new_bundle_wrapper.insertAfter(bundle_wrapper);

        update_item_total_price(self);
      }

      close_all_options();

      reset_all_variants(self);
    }

    /**
       * Remove the bundle.
       */
    function remove_bundle() {
      var self = $(this),
          bundle_variants = self.closest('.bundle-variants'),
          bundle_wrapper = self.closest('.bundle-variants-wrapper'),
          bundle_prev = bundle_wrapper.prev();

      enable_next_options(self);

      bundle_wrapper.remove();

      close_all_options();


      update_item_total_price(bundle_variants);
    }

    /**
       * Array jQuery Form Serialize
       * 
       * @param {Array} data Array jQuery Form Serialize 
       */
    function filter_data(data) {
      return data.filter(function (d) {
        return !/^bundle/gi.test(d.name);
      })
    }

    /**
       * Function that prepare data for add on ATC.
       * 
       * @param {Array} data Filtered Array jQuery Form Serialize
       */
    function prepare_data(data) {
      var result = { updates: {} };

      for (var i = 0, j = data.length - 1; i < j; i += 2) {
        if (!/^choose/gi.test(data[i].value)) {
          result.updates[data[i].value] = data[i + 1].value;
        }
      }

      return result;
    }

    function cartUpdate(data) {
      return $.ajax({
        url: '/cart/update.js',
        data: data,
        type: 'POST',
        dataType: 'json'
      });
    }

    function addItems(data) {
      return $.ajax({
        url: '/cart/add.js',
        data: data,
        type: 'POST',
        dataType: 'json'
      });
    }

    function getAllItems() {
      return $.ajax({
        url: '/cart.js',
        type: 'POST',
        dataType: 'json'
      });
    }

    /**
       * Function that add bundle product to ATC.
       * 
       * @param {Object} event Submit event
       */
    async function add_to_bundle_cart(event) {
      var data = $(this).serializeArray(),
          items = [],
          timestamp = (new Date).getTime(),
          assemblyType = $('[name="note"]:checked').val();

      data = filter_data(data);
      data = prepare_data(data);

      $('.btn-add-tocart').prop('disabled', true);

      for(var variantid in data.updates) {
        items.push({
          quantity: data.updates[variantid],
          id: variantid,
          properties: {
            Assembly: assemblyType,
            Bundle: timestamp
          }
        });
      }

      addItems({items: items}).then(function(r, s){
        if (s == 'success') {
          window.location.href = '/cart?view=bundle';
        }
      }).catch(function(err){
        throw err;
      });

      event.preventDefault();

      return false;
    }

    /**
       * 
       * @param {Object} filter
       */
    function empty_filter(filter) {
      $('.bundle-filter').val('');
      $('.bundle-item.hide').removeClass('hide');
    }

    /**
       * Filter bundle products on keyup on input.
       */
    function filter_bundle_products() {
      var self = $(this),
          value = self.val().toLocaleLowerCase(),
          bundle_items = self.closest('.bundle-product-mask').find('.bundle-item:not(.active)'),
          querysearch,
          item,
          regex;

      if (value.length > 0) {
        bundle_items.each(function () {
          item = $(this);
          querysearch = (item.text() + ';' + item.attr('data-vendor')).toLocaleLowerCase() ;

          if (querysearch.indexOf(value) > -1) {
            item.removeClass('hide');
          } else {
            item.addClass('hide');
          }
        });
      } else {
        bundle_items.removeClass('hide');
      }
    }

    function resetBundle( event ) {
      var article = $(this).closest('.item-single');

      event.preventDefault();

      article.find('[data-value="choose-variant"]').trigger('click');
    }

    function confirmBundle(event) {

      event.preventDefault();

      $('body').addClass('opened-bundle-modal');
    }

    function submitBundleForm(event) {
      $('#bundle-form').trigger('submit');

      event.preventDefault();
    }

    function closeModal(event) {
      $('body').removeClass('opened-bundle-modal');

      event.preventDefault();
    }

    // Execute code
    $(document).ready(function () {
      var $document = $(this);

      $('.all-bundle-variants').val('choose-variant').trigger('change');

      $document.on('click', '.bundle-product-mask', open_bundle_options);
      $document.on('click', '.bundle-product-mask > .bundle-item:not(.bundle-item-filter)', select_bundle_option);
      $document.on('click', '.bundle-minus', remove_bundle);
      $document.on('click', 'body', close_all_options);
      $document.on('keyup', '.bundle-filter', filter_bundle_products);
      $document.on('change', '.all-bundle-variants', change_variant);
      $document.on('click', '.btn-remove', resetBundle);

      $document.on('click', '#bundle-add-to-cart', confirmBundle);
      $document.on('click', '#modal-add-to-cart', submitBundleForm);

      $document.on('submit', '#bundle-form', add_to_bundle_cart);

      $document.on('click', '.modal-close', closeModal);
    });

    window.addEventListener('load', function(){
      $('.bundle-item-image').each(function(){
        var src = $(this).attr('data-src');

        $(this).attr('src', src).css('opacity', '1');
      });

      $('#bundle-subtotal-price').html(Shopify.formatMoney(0, '${{amount}}'));
    });
  })(jQuery);
})